import { createContext, Dispatch } from 'react'
import { IPublishScheduleActionType, IPublishScheduleFormState } from '../../types/publishSchedule'
import { initialState } from '../../reducers/publishSchedule'

export const PublishScheduleStateContext = createContext<IPublishScheduleFormState>(initialState)
export const PublishScheduleDispatchContext = createContext<Dispatch<IPublishScheduleActionType>>(
  () => { throw new Error('Dispatch was not provided to context') }
)
